import baseUrl from '../baseUrl';

export default function createApiUrl(sitecode, version) {
  return `${baseUrl(sitecode)}/API/${version}`;
}
